var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"large":"","color":"primary","depressed":""},on:{"click":_vm.generate}},[_c('img',{staticClass:"tw-pr-2",attrs:{"src":require("@/assets/icons/download.svg"),"alt":""}}),_vm._v(" Download Letter(s) ")]),_c('FileDownloadingDialog',{ref:"downloadingDialog"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }